import { render, staticRenderFns } from "./custom_table.vue?vue&type=template&id=51941c05&scoped=true"
import script from "./custom_table.vue?vue&type=script&lang=js"
export * from "./custom_table.vue?vue&type=script&lang=js"
import style0 from "./custom_table.vue?vue&type=style&index=0&id=51941c05&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51941c05",
  null
  
)

export default component.exports